const clientStyles = [
    {
        name: 'akaku',
        background: 'rgba(24,41,71,1)',
        textColor: 'white',
        appName: 'Maui Stream',
        packageName: 'com.mauiStream.app',
        bundleIdentifier: 'com.mauiStream.app',
        scheme: 'mauistream',
        appID: '1611402597',
        closeIcon: '',
        buttonBackground: '',
        buttonText: 'rgba(24,41,71,1)'
    }, {
        name: 'frostburgtv3',
        background: '#525252',
        textColor: 'white',
        appName: 'FSU-TV3',
        packageName: 'com.frostburg.app',
        bundleIdentifier: 'com.frostburg.app',
        scheme: 'frostburgtv3',
        appID: '6443548138',
        closeIcon: '',
        buttonBackground: 'rgba(234, 0, 41, 1)',
        buttonText: 'white' 
    }, {
        name: 'andover',
        background: 'white',
        textColor: 'rgba(18,108,177,1)',
        appName: 'AndoverTV',
        packageName: 'com.andoverTv.app',
        bundleIdentifier: 'com.andoverTv.app',
        scheme: 'andovertv',
        appID: '1623004303',
        closeIcon: 'rgba(18,108,177,0.5)',
        buttonBackground: 'rgba(18,108,177,1)',
        buttonText: 'white' 
    },
    {
        name: 'avon-lake',
        background: 'rgba(230,163,37, 1)',
        textColor: 'black',
        appName: 'ALC-TV',
        packageName: 'com.alctv.app',
        bundleIdentifier: 'com.alctv.app',
        scheme: 'avonlaketv',
        appID: '1627048337',
        closeIcon: '',
        buttonBackground: 'black',
        buttonText: 'white'
    }, {
        name: 'cantv',
        background: 'white',
        textColor: 'black',
        appName: 'can tv+',
        packageName: 'com.canTv.app',
        bundleIdentifier: 'com.canTv.app',
        scheme: 'cantvchicago',
        appID: '6443928485',
        closeIcon: 'rgba(0,0,0,0.1)',
        buttonBackground: 'rgb(230,34,37)',
        buttonText: 'white' 
    }, {
        name: 'charlestown',
        background: '#ffffff',
        textColor: 'black',
        appName: 'Charlestown Community TV',
        packageName: 'com.charlestownCommunityTv.app',
        bundleIdentifier: 'com.charlestownCommunityTv.app',
        scheme: 'charlestowncommunitytv',
        appID: '6465792870',
        closeIcon: 'rgba(0,0,0,0.1)',
        buttonBackground: 'rgb(1,176,86)',
        buttonText: 'white' 
    },     {
        name: 'aurora',
        background: 'white',
        textColor: 'rgb(0,64,107)',
        appName: 'City of Aurora',
        packageName: 'com.cityOfAurora.app',
        bundleIdentifier: 'com.cityOfAurora.app',
        scheme: 'cityofaurora',
        appID: '6451054663',
        closeIcon: 'rgba(0,0,0,0.1)',
        buttonBackground: 'rgb(0,64,107)',
        buttonText: 'white'
    }, {
        name: 'fridley',
        background: 'rgb(42,43,121)',
        textColor: 'white',
        appName: 'City Of Fridley',
        packageName: 'com.cityOfFridley.app',
        bundleIdentifier: 'com.cityOfFridley.app',
        scheme: 'cityoffridley',
        appID: '6451214636',
        closeIcon: '',
        buttonBackground: '',
        buttonText: 'rgb(42,43,121)' 
    }, {
        name: 'hsv-tv',
        background: 'white',
        textColor: 'black',
        appName: 'City of Huntsville',
        packageName: 'com.cityOfHuntsville.app',
        bundleIdentifier: 'com.cityOfHuntsville.app',
        scheme: 'cityofhuntsville',
        appID: '6451457814',
        closeIcon: 'rgba(0,0,0,0.1)',
        buttonBackground: 'rgb(11,78,94)',
        buttonText: 'white' 
    },
    {
        name: 'shoreline',
        background: 'white',
        textColor: 'rgb(1,151,91)',
        appName: 'City Of Shoreline',
        packageName: 'com.cityOfShoreline.app',
        bundleIdentifier: 'com.cityOfShoreline.app',
        scheme: 'cityofshoreline',
        appID: '6465788962',
        closeIcon: 'rgba(0,0,0,0.1)',
        buttonBackground: 'rgb(2,96,181)',
        buttonText: 'white'
    }, {
        name: 'etvlive',
        background: 'white',
        textColor: 'black',
        appName: 'Huntsville City Schools',
        packageName: 'com.huntsvilleCitySchools.app',
        bundleIdentifier: 'com.huntsvilleCitySchools.app',
        scheme: 'huntsvillecityschools',
        appID: '6450905949',
        closeIcon: 'rgba(0,0,0,0.1)',
        buttonBackground: 'rgb(25,55,105)',
        buttonText: 'white' 
    }, {
        // name: 'milford-vod',
        // background: 'white',
        // textColor: 'black',
        // appName: 'Milford TV',
        // packageName: 'com.milfordTv.app',
        // bundleIdentifier: 'com.milfordTv.app',
        // scheme: 'milfordtv',
        // appID: '1616542379',
        // closeIcon: 'rgba(0,0,0,0.1)',
        // buttonBackground: 'rgb(158, 5, 19)',
        // buttonText: 'white' 
    },     {
        name: 'tbnk',
        background: 'black',
        textColor: 'white',
        appName: 'TBNK To Go',
        packageName: 'com.TBNKVOD.ui',
        bundleIdentifier: 'com.TBNK-VOD.ui',
        scheme: 'tbnktogo',
        appID: '1513940600',
        closeIcon: '',
        buttonBackground: 'rgb(30, 77, 125)',
        buttonText: 'white'
    }, {
        name: 'thumbcoast',
        background: 'white',
        textColor: 'black',
        appName: 'Thumbcoast.tv',
        packageName: 'com.thumbCoast.app',
        bundleIdentifier: 'com.thumbCoast.app',
        scheme: 'thumbcoasttv',
        appID: '6444201237',
        closeIcon: 'rgba(0,0,0,0.1)',
        buttonBackground: 'rgba(29, 63, 117, 1)',
        buttonText: 'white' 
    }, {
        name: 'tyngsborough',
        background: 'white',
        textColor: 'black',
        appName: 'Tyngsborough Media',
        packageName: 'com.tyngsborough.app',
        bundleIdentifier: 'com.tyngsborough.app',
        scheme: 'tyngsboroughmedia',
        appID: '6450189099',
        closeIcon: 'rgba(0,0,0,0.1)',
        buttonBackground: 'black',
        buttonText: 'white' 
    }, {
        name: 'westchester',
        background: '#006937',
        textColor: 'white',
        appName: 'West Chester TV',
        packageName: 'com.westChester.app',
        bundleIdentifier: 'com.westChester.app',
        scheme: 'westchestertv',
        appID: '6443740492',
        closeIcon: '',
        buttonBackground: 'white',
        buttonText: '#006937'
    }, {
        name: '8stringtv',
        background: 'white',
        textColor: 'black',
        appName: '8 String TV',
        packageName: 'com.stringtv.tv',
        bundleIdentifier: 'com.stringtv.ui',
        scheme: 'eightstringtv',
        appID: '1568505150',
        closeIcon: 'rgba(0,0,0,0.1)',
        buttonBackground: 'rgba(93,0,224,1)',
        buttonText: 'white' 
    }, {
        name: 'kputv',
        background: 'rgb(34, 86, 98)',
        textColor: 'white',
        appName: 'KPU TV+',
        packageName: 'com.ketchikanPublicUtilities.app',
        bundleIdentifier: 'com.ketchikanPublicUtilities.app',
        scheme: 'kputv',
        appID: '6473753413',
        closeIcon: '',
        buttonBackground: 'white',
        buttonText: 'rgb(34, 86, 98)' 
    }, {
        // 'rgb(242,129,0)' rgba(47, 46, 46, 1) white
        name: 'waycam',
        background: 'white',
        textColor: 'rgba(47, 46, 46, 1)',
        appName: 'WayCAM.tv',
        packageName: 'com.wayCamTv.app',
        bundleIdentifier: 'com.wayCamTv.app',
        scheme: 'waycamtv',
        appID: '6446644819',
        closeIcon: 'rgba(0,0,0,0.1)',
        buttonBackground: 'rgb(242,129,0)',
        buttonText: '' 
    }, {
        name: 'monroe',
        background: 'white',
        textColor: 'rgba(36, 61, 89, 1)',
        appName: 'Monroe County TV',
        packageName: 'com.monroe.tv',
        bundleIdentifier: 'com.goodbarber.mcbocc',
        scheme: 'monroecounty',
        appID: '915008833',
        closeIcon: 'rgba(0,0,0,0.1)',
        buttonBackground: 'rgba(36, 61, 89, 1)',
        buttonText: 'white' 
    }, {
        name: 'olympia',
        background: 'white',
        textColor: '',
        appName: 'OLYTV',
        packageName: 'com.cityOfOlympia.app',
        bundleIdentifier: 'com.cityOfOlympia.app',
        scheme: 'olytv',
        appID: '6478711681',
        closeIcon: 'rgba(0,0,0,0.1)',
        buttonBackground: 'rgb(34,87,122)',
        buttonText: 'white' 
    }, {
        name: 'westfordcat',
        background: 'black',
        textColor: 'white',
        appName: 'Westford CAT',
        packageName: 'com.WestfordCAT.ui',
        bundleIdentifier: 'com.westfordCat.app',
        scheme: 'westfordcat',
        appID: '1636368660',
        closeIcon: '',
        buttonBackground: '',
        buttonText: '' 
    }, {
        name: 'missoula',
        background: 'white',
        textColor: 'black',
        appName: 'Missoula Tv',
        packageName: 'com.missoulaTv.app',
        bundleIdentifier: 'com.missoulaTv.app',
        scheme: 'missoulatv',
        appID: '1636741261',
        closeIcon: 'rgba(0,0,0,0.1)',
        buttonBackground: 'rgb(190, 214, 48)',
        buttonText: 'black' 
    }, {
        name: 'san-leandro',
        background: 'white',
        textColor: 'black',
        appName: 'City of San Leandro',
        packageName: 'com.cityOfSanLeandro.app',
        bundleIdentifier: 'com.cityOfSanLeandro.app',
        scheme: 'cityofsanleandro',
        appID: '6593660299',
        closeIcon: 'rgba(0,0,0,0.1)',
        buttonBackground: 'rgb(141, 55, 70)',
        buttonText: 'white' 
    }, {
        name: 'ripon',
        background: 'white',
        textColor: 'black',
        appName: 'City of Ripon',
        packageName: 'com.cityOfRipon.app',
        bundleIdentifier: 'com.cityOfRipon.app',
        scheme: 'cityofripon',
        appID: '6587583366',
        closeIcon: 'rgba(0,0,0,0.1)',
        buttonBackground: 'rgba(46, 78, 111, 1)',
        buttonText: 'white' 
    }, {
        name: 'pflugerville',
        background: 'white',
        textColor: 'black',
        appName: 'Pflugerville Media',
        packageName: 'com.pflugervilleMedia.app',
        bundleIdentifier: 'com.pflugervilleMedia.app',
        scheme: 'pflugervillemedia',
        appID: '6587582948',
        closeIcon: 'rgba(0,0,0,0.1)',
        buttonBackground: 'rgb(0, 91, 153)',
        buttonText: 'white' 
    }, {
        name: 'epping',
        background: 'white',
        textColor: 'black',
        appName: 'ETV 22!',
        packageName: 'com.eppingTv.app',
        bundleIdentifier: 'com.eppingTv.app',
        scheme: 'eppingtv',
        appID: '6587581200',
        closeIcon: 'rgba(0,0,0,0.1)',
        buttonBackground: 'rgb(3,52,125)',
        buttonText: 'white' 
    }, {
        name: 'template',
        background: '',
        textColor: '',
        appName: '',
        packageName: 'com.x.app',
        bundleIdentifier: 'com.x.app',
        scheme: '',
        appID: '',
        closeIcon: '',
        buttonBackground: '',
        buttonText: '' 
    }
]

const defaultStyle = {
    name: 'default',
    icon: null,
    background: 'white',
    textColor: 'black'
}

export const getClientStyle = client => clientStyles.find(x => x.name === client) || defaultStyle